/* eslint-disable import/prefer-default-export */
import appConfig from '../config';
import { Device } from 'enums';

const {
    isBeta
} = appConfig;

export const nrCookie = `
    if (${isBeta} || (window.location.origin && window.location.origin.indexOf('espnqa') >= 0)) {
        document.cookie = "_nr=1; path=/; expires=${new Date(Date.now() + 604800000)}"; // 1 week cookie
    }
`;

// list of varnish x-deivce values
// https://github.disney.com/SEESPN/seespn_varnish/blob/4257d10478d4556183497914c22157aa08761613/files/default/etc/varnish/vcl/device.vcl#L50
// Map of X-Device values to supports device values of PageAPI
export const xDeviceMap = {
    pc: Device.DESKTOP,
    'pc-generic': Device.DESKTOP,
    mobile: Device.HANDSET,
    'mobile-generic': Device.HANDSET,
    'mobile-smartphone': Device.HANDSET,
    tablet: Device.TABLET
};



// WEBPACK FOOTER //
// ./app/constants.js